var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"object-fit":"contain"},attrs:{"src":require("@/assets/images/transunion.png"),"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }